import { render } from "./GaugeQuestion.vue?vue&type=template&id=6dcaf1f3"
import script from "./GaugeQuestion.vue?vue&type=script&lang=js"
export * from "./GaugeQuestion.vue?vue&type=script&lang=js"

import "./GaugeQuestion.vue?vue&type=style&index=0&id=6dcaf1f3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__